export default __webpack_public_path__ + "static/media/offline.0599da3f.svg";